// StateContract — stateContract in meta.json for runtime access control

import type { VariableDef } from "../schema/state.ts";

export interface InputSymbol {
  name: string;
  path: string; // e.g., "#{appData.products}"
  type: string; // "array", "object", "string", "number", "boolean", "unknown"
}

export interface OutputSymbol {
  name: string;
  path: string; // e.g., "#{appData.cart.items}"
  type: string;
}

export interface StateContract {
  localState: Record<string, VariableDef>;  // @{} scope
  inputSymbols: InputSymbol[];               // read-allowed external paths
  outputSymbols: OutputSymbol[];             // write-allowed external paths
}

export class SecurityError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SecurityError";
  }
}
